import { z } from 'zod'

/** รูปที่ถ่าย — เก็บเป็น assetId ที่ชี้ไปยังไฟล์บน R2 */
export const PhotoRefSchema = z.strictObject({
  assetId: z.string().min(1),
  capturedAt: z.number().int().optional(),
})
export type PhotoRef = z.infer<typeof PhotoRefSchema>

export const GpsValueSchema = z.strictObject({
  lat: z.number(),
  lng: z.number(),
  accuracy: z.number().optional(),
})
export type GpsValue = z.infer<typeof GpsValueSchema>

export const AnswerValueSchema = z.union([
  z.string(),
  z.number(),
  z.null(),
  z.array(z.string()),
  z.array(PhotoRefSchema),
  GpsValueSchema,
])
export type AnswerValue = z.infer<typeof AnswerValueSchema>

/** คำตอบของหนึ่งขั้นตอน: { ชื่อฟิลด์: ค่า } */
export const StepAnswersSchema = z.record(z.string(), AnswerValueSchema)
export type StepAnswers = z.infer<typeof StepAnswersSchema>

/**
 * "ตอบแล้วหรือยัง" — ค่าว่าง/อาเรย์ว่าง/null ถือว่ายังไม่ตอบ
 * ใช้ร่วมกันทั้ง validation, เงื่อนไขเส้นทาง และการแสดงผลในหลังบ้าน
 * เพื่อไม่ให้แต่ละที่ตีความ "ว่าง" ไม่ตรงกัน
 */
export function isAnswered(value: AnswerValue | undefined): boolean {
  if (value === undefined || value === null) return false
  if (typeof value === 'string') return value.trim().length > 0
  if (typeof value === 'number') return Number.isFinite(value)
  if (Array.isArray(value)) return value.length > 0
  return true
}

/** แปลงคำตอบเป็นข้อความสำหรับแสดงผล/เปรียบเทียบ */
export function answerToText(value: AnswerValue | undefined): string {
  if (value === undefined || value === null) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'number') return String(value)
  if (Array.isArray(value)) {
    return value
      .map((item) => (typeof item === 'string' ? item : `รูปภาพ (${item.assetId.slice(0, 8)})`))
      .join(', ')
  }
  return `${value.lat.toFixed(6)}, ${value.lng.toFixed(6)}`
}

/** คำตอบเป็นรายการข้อความหรือไม่ (เลือกหลายข้อ) */
export function asStringArray(value: AnswerValue | undefined): string[] {
  if (Array.isArray(value)) return value.filter((item): item is string => typeof item === 'string')
  return []
}

export function asPhotoRefs(value: AnswerValue | undefined): PhotoRef[] {
  if (Array.isArray(value)) {
    return value.filter((item): item is PhotoRef => typeof item === 'object' && item !== null)
  }
  return []
}
